import { useEffect, useState } from 'react';
import { isOnline, subscribeConnectivity } from './connectivity';
import type { SyncState } from './sync';
import { subscribeSync } from './sync';

/** The outbox and the signal, for the banner. */
export function useSync(): SyncState & { online: boolean } {
  const [state, setState] = useState<SyncState>({
    queued: 0, draining: false, problems: [], lastSentAt: null,
  });
  const [online, setOnline] = useState(isOnline());

  useEffect(() => subscribeSync(setState), []);
  useEffect(() => subscribeConnectivity(setOnline), []);

  return { ...state, online };
}
